(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product-video"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__hummaCardVideo) return;
  window.__hummaCardVideo = true;

  const dialog = document.querySelector('[data-card-video-dialog]');
  if (!dialog) return;

  const stage = dialog.querySelector('[data-card-video-stage]');

  const safeHttpUrl = (value) => {
    if (!value) return '';
    try {
      const url = new URL(value, window.location.origin);
      if (url.protocol === 'https:' || url.protocol === 'http:') return url.href;
    } catch (error) {
      return '';
    }
    return '';
  };

  const safeId = (value) => {
    if (!value || !/^[\w-]{3,}$/.test(value)) return '';
    return value;
  };

  const clearStage = () => {
    stage.replaceChildren();
  };

  // A native modal dialog still lets the page behind it scroll, so reuse the
  // class the theme's own drawers and modals use. Remember whether something
  // else had already locked the page, so closing the video does not unlock a
  // drawer that is still open underneath.
  let bodyWasLocked = false;

  const lockBody = () => {
    bodyWasLocked = document.body.classList.contains('overflow-hidden');
    document.body.classList.add('overflow-hidden');
  };

  const unlockBody = () => {
    if (!bodyWasLocked) document.body.classList.remove('overflow-hidden');
  };

  const closeDialog = () => {
    clearStage();
    if (dialog.open) dialog.close();
  };

  const openDialog = (opener) => {
    const kind = opener.dataset.videoKind;
    const title = opener.dataset.videoTitle || '';
    clearStage();

    if (kind === 'youtube' || kind === 'vimeo') {
      const id = safeId(opener.dataset.videoSrc);
      if (!id) return;
      const iframe = document.createElement('iframe');
      iframe.title = title;
      iframe.allowFullscreen = true;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.src =
        kind === 'youtube'
          ? `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0`
          : `https://player.vimeo.com/video/${encodeURIComponent(id)}?autoplay=1`;
      stage.append(iframe);
    } else {
      const src = safeHttpUrl(opener.dataset.videoSrc);
      if (!src) return;
      const video = document.createElement('video');
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.src = src;
      const poster = safeHttpUrl(opener.dataset.videoPoster);
      if (poster) video.poster = poster;
      if (title) video.setAttribute('aria-label', title);
      stage.append(video);
    }

    if (title) dialog.setAttribute('aria-label', title);
    if (!dialog.open) {
      lockBody();
      dialog.showModal();
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const opener = event.target.closest('[data-card-video-open]');
      if (!opener) return;
      event.preventDefault();
      event.stopPropagation();
      openDialog(opener);
    },
    true
  );

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog || event.target.closest('[data-card-video-close]')) closeDialog();
  });

  dialog.addEventListener('close', () => {
    clearStage();
    unlockBody();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('.product-form__size-guide');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href || href.charAt(0) !== '#') return;

    const tabs = document.querySelector('product-info-tabs');
    if (tabs && href === '#size-guide' && typeof tabs.openTab === 'function') {
      event.preventDefault();
      tabs.openTab('size', { scroll: true });
      if (history.replaceState) {
        history.replaceState(null, '', href);
      }
      return;
    }

    const target = document.getElementById(href.slice(1));
    if (!target) return;

    event.preventDefault();

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const header = document.querySelector('sticky-header, .shopify-section-header-sticky');
    const headerOffset = header ? Math.round(header.getBoundingClientRect().height) : 0;
    const top = Math.max(target.getBoundingClientRect().top + window.scrollY - headerOffset, 0);

    window.scrollTo({
      top,
      behavior: reduceMotion ? 'auto' : 'smooth',
    });

    if (history.replaceState) {
      history.replaceState(null, '', href);
    }

    if (!target.hasAttribute('tabindex')) {
      target.setAttribute('tabindex', '-1');
    }
    target.focus({ preventScroll: true });
  });
  } catch(e) { console.error(e); }
})();

})();
